"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferenceCalendarCms = void 0;
var PreferenceCalendarCms = /** @class */ (function () {
    function PreferenceCalendarCms() {
        this.availableAppointmentText = 'I prefer the earliest available appointment.';
        this.customAppointmentText = 'I prefer a specific day and timeframe';
        this.availabilityText = "We'll do our best to accommodate your preferences.\n    We'll send you an email with your confirmed appointment date and timeframe.";
        this.installationHeader = 'Schedule your appointment preference';
        this.SchedulerHeading = 'My availability';
        this.earliestAppointmentHeading = 'Installation appointment';
        this.saveActionLabel = 'Add my preference';
        this.arrivalLabel = 'Technician\'s arrival window ';
        this.description = "Who do we contact on the day of installation? Be sure\n    someone who's at least 18 years old and able to act on your behalf is home throughout\n    the entire visit.";
    }
    return PreferenceCalendarCms;
}());
exports.PreferenceCalendarCms = PreferenceCalendarCms;
//# sourceMappingURL=PreferenceCalendar.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/InstallationCard/PreferenceCalendar/PreferenceCalendar.cms.js
// module id = 959
// module chunks = 8